// Custom JavaScript for Ed-Haibike theme
// Collection filters are handled by ed-collection-filters.js
const links = document.links; 
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) { 
    if (links[i].hostname !== window.location.hostname) { 
      links[i].target = '_blank'; 
      links[i].rel = 'noreferrer noopener'; 
  } 
}

if (/Android/i.test(navigator.userAgent)) {
  document.documentElement.classList.add('android');
}